let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("f275C")).then(() => parcelRequire('2N2w4'));